// extracted by mini-css-extract-plugin
export default {"root":"Step1Form_root__OTy-E"};